import React from "react";
import { Form } from "react-bootstrap";
import SmuButton from "../../../utils/smu-button/SmuButton";


const Link = ({ url, info }) => {
  return (
    <a href={`${url}`} target="_blank"> {info} </a>
  );
}

const RecentItem = ({
  icon,
  primaryInfo,
  secondaryInfo,
  controlIcon,
  control,
  loading,
  link = false
}) => {

  let primary = (link == false) ? primaryInfo : <Link url={link} info={primaryInfo} />;

  return (
    <div className="recent-item">
      <label className="d-flex m-0 w-100 c-pointer text-truncate">
        {/* <div className="section__icon mx-2">
          <img src={icon} alt="ITEM ICON" />
        </div> */}
        <div className="section__info text-truncate ms-4">
          <div className="primary-info text-truncate">
            {primary}
          </div>
          {Boolean(secondaryInfo) && (
            <div className="secondary-info text-truncate">{secondaryInfo}</div>
          )}
        </div>
      </label>
      {
        link == false &&
        <div className="section__control ms-2">
          <SmuButton control={() => control()} loading={loading}>{controlIcon}</SmuButton>
        </div>
      }
    </div>
  );
};

export default RecentItem;
